import React, { Fragment } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { DeleteInvoice } from '../API/InvoiceAPI';
import { toast } from 'react-toastify';

const DeleteDraftModal = ({ delDraft, setDelDraft, deleteInvoiceData, setDeleteInvoiceData, setDraftDel, draftDel }) => {

    const handleOnclickDelete = async () => {
        const params = {
            invoice_items_id: deleteInvoiceData.invoice_items_id
        };

        const result = await DeleteInvoice(params)
        if (result) {
            setDelDraft(false)
            setDeleteInvoiceData('')
            setDraftDel(!draftDel)
            toast.error("Invoice deleted successfully", { autoClose: 5000 });
        } else {
            toast.error("Something went wrong", { autoClose: 5000 });
        }
    }

    return (
        <div>
            <Transition.Root show={delDraft} as={Fragment}>
                <Dialog as="div" className="relative z-10" onClose={setDelDraft}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-[#c1c9d2b3]" />
                    </Transition.Child>

                    <div className="fixed inset-0 z-10 overflow-y-auto">
                        <div className="flex min-h-full justify-center p-4 text-center items-center sm:p-0">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                enterTo="opacity-100 translate-y-0 sm:scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            >
                                <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm">
                                    <div className='p-[20px]'>
                                        <div className="text-[#414552]">
                                            <div className="font-semibold text-[#1a1b25] text-base">Delete draft invoice</div>
                                            <p className="text-[14px] mt-1">Are you sure you want to permanently delete this draft invoice? This cannot be undone.</p>
                                        </div>
                                        <div className="flex justify-end gap-2 mt-2">
                                            <button className="input_focus_shadow h-[30px] rounded-[6px] text-[14px] font-semibold p-[0_8px] flex items-center gap-2" onClick={() => { setDelDraft(false); setDeleteInvoiceData('') }}>Cancel</button>
                                            <button onClick={handleOnclickDelete} className="h-[30px] rounded-[8px] bg-[#df1b41] border-[##df1b41] text-[14px] font-semibold p-[0_8px] flex items-center gap-2 text-white leading-[30px]">Delete draft</button>
                                        </div>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition.Root>
        </div>
    )
}

export default DeleteDraftModal